import {GetSeferData} from "SeferPetach/GetData";

export async function changePassword(obj) {    
    var args = {...obj};
    var payload = await GetSeferData("usf4", args);
    return (payload);
}
export async function changeSelfData(obj) {    
    var args = {...obj};
    var payload = await GetSeferData("usf5", args);
    return (payload);
}
export async function getSelfData() {    
    var args = {};
    var payload = await GetSeferData("usf6", args);
    return (payload);
}